/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { InspectionDataCategoryDto } from '../models/inspection-data-category-dto';
import { inspectionDataControllerCreate } from '../fn/inspection-data/inspection-data-controller-create';
import { InspectionDataControllerCreate$Params } from '../fn/inspection-data/inspection-data-controller-create';
import { inspectionDataControllerCreateCategory } from '../fn/inspection-data/inspection-data-controller-create-category';
import { InspectionDataControllerCreateCategory$Params } from '../fn/inspection-data/inspection-data-controller-create-category';
import { inspectionDataControllerDelete } from '../fn/inspection-data/inspection-data-controller-delete';
import { InspectionDataControllerDelete$Params } from '../fn/inspection-data/inspection-data-controller-delete';
import { inspectionDataControllerDeleteCategory } from '../fn/inspection-data/inspection-data-controller-delete-category';
import { InspectionDataControllerDeleteCategory$Params } from '../fn/inspection-data/inspection-data-controller-delete-category';
import { inspectionDataControllerFindAll } from '../fn/inspection-data/inspection-data-controller-find-all';
import { InspectionDataControllerFindAll$Params } from '../fn/inspection-data/inspection-data-controller-find-all';
import { inspectionDataControllerFindAllCategories } from '../fn/inspection-data/inspection-data-controller-find-all-categories';
import { InspectionDataControllerFindAllCategories$Params } from '../fn/inspection-data/inspection-data-controller-find-all-categories';
import { inspectionDataControllerFindByChildId } from '../fn/inspection-data/inspection-data-controller-find-by-child-id';
import { InspectionDataControllerFindByChildId$Params } from '../fn/inspection-data/inspection-data-controller-find-by-child-id';
import { inspectionDataControllerFindById } from '../fn/inspection-data/inspection-data-controller-find-by-id';
import { InspectionDataControllerFindById$Params } from '../fn/inspection-data/inspection-data-controller-find-by-id';
import { inspectionDataControllerSearchCategories } from '../fn/inspection-data/inspection-data-controller-search-categories';
import { InspectionDataControllerSearchCategories$Params } from '../fn/inspection-data/inspection-data-controller-search-categories';
import { inspectionDataControllerUpdate } from '../fn/inspection-data/inspection-data-controller-update';
import { InspectionDataControllerUpdate$Params } from '../fn/inspection-data/inspection-data-controller-update';
import { inspectionDataControllerUpdateCategory } from '../fn/inspection-data/inspection-data-controller-update-category';
import { InspectionDataControllerUpdateCategory$Params } from '../fn/inspection-data/inspection-data-controller-update-category';
import { InspectionDataDto } from '../models/inspection-data-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class InspectionDataService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `inspectionDataControllerFindAll()` */
  static readonly InspectionDataControllerFindAllPath = '/api/inspection-data';

  /**
   * 검사 자료 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerFindAll$Response(params?: InspectionDataControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InspectionDataDto>>> {
    return inspectionDataControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 자료 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerFindAll(params?: InspectionDataControllerFindAll$Params, context?: HttpContext): Observable<Array<InspectionDataDto>> {
    return this.inspectionDataControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InspectionDataDto>>): Array<InspectionDataDto> => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerCreate()` */
  static readonly InspectionDataControllerCreatePath = '/api/inspection-data';

  /**
   * 검사 자료 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inspectionDataControllerCreate$Response(params: InspectionDataControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataDto>> {
    return inspectionDataControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 자료 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inspectionDataControllerCreate(params: InspectionDataControllerCreate$Params, context?: HttpContext): Observable<InspectionDataDto> {
    return this.inspectionDataControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<InspectionDataDto>): InspectionDataDto => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerFindAllCategories()` */
  static readonly InspectionDataControllerFindAllCategoriesPath = '/api/inspection-data/category';

  /**
   * 검사 자료 카테고리 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerFindAllCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerFindAllCategories$Response(params?: InspectionDataControllerFindAllCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InspectionDataCategoryDto>>> {
    return inspectionDataControllerFindAllCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 자료 카테고리 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerFindAllCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerFindAllCategories(params?: InspectionDataControllerFindAllCategories$Params, context?: HttpContext): Observable<Array<InspectionDataCategoryDto>> {
    return this.inspectionDataControllerFindAllCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InspectionDataCategoryDto>>): Array<InspectionDataCategoryDto> => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerCreateCategory()` */
  static readonly InspectionDataControllerCreateCategoryPath = '/api/inspection-data/category';

  /**
   * 검사 자료 카테고리 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerCreateCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inspectionDataControllerCreateCategory$Response(params: InspectionDataControllerCreateCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataCategoryDto>> {
    return inspectionDataControllerCreateCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 자료 카테고리 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerCreateCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inspectionDataControllerCreateCategory(params: InspectionDataControllerCreateCategory$Params, context?: HttpContext): Observable<InspectionDataCategoryDto> {
    return this.inspectionDataControllerCreateCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<InspectionDataCategoryDto>): InspectionDataCategoryDto => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerSearchCategories()` */
  static readonly InspectionDataControllerSearchCategoriesPath = '/api/inspection-data/category/search';

  /**
   * 검사 자료 카테고리 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerSearchCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerSearchCategories$Response(params: InspectionDataControllerSearchCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return inspectionDataControllerSearchCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 자료 카테고리 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerSearchCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerSearchCategories(params: InspectionDataControllerSearchCategories$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.inspectionDataControllerSearchCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerFindByChildId()` */
  static readonly InspectionDataControllerFindByChildIdPath = '/api/inspection-data/child';

  /**
   * 아동 검사 자료 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerFindByChildId()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerFindByChildId$Response(params: InspectionDataControllerFindByChildId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InspectionDataDto>>> {
    return inspectionDataControllerFindByChildId(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동 검사 자료 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerFindByChildId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerFindByChildId(params: InspectionDataControllerFindByChildId$Params, context?: HttpContext): Observable<Array<InspectionDataDto>> {
    return this.inspectionDataControllerFindByChildId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InspectionDataDto>>): Array<InspectionDataDto> => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerFindById()` */
  static readonly InspectionDataControllerFindByIdPath = '/api/inspection-data/{id}';

  /**
   * 아동 검사 자료 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerFindById$Response(params: InspectionDataControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataDto>> {
    return inspectionDataControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 아동 검사 자료 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerFindById(params: InspectionDataControllerFindById$Params, context?: HttpContext): Observable<InspectionDataDto> {
    return this.inspectionDataControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<InspectionDataDto>): InspectionDataDto => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerDelete()` */
  static readonly InspectionDataControllerDeletePath = '/api/inspection-data/{id}';

  /**
   * 검사 자료 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerDelete$Response(params: InspectionDataControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataDto>> {
    return inspectionDataControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 자료 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerDelete(params: InspectionDataControllerDelete$Params, context?: HttpContext): Observable<InspectionDataDto> {
    return this.inspectionDataControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<InspectionDataDto>): InspectionDataDto => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerUpdate()` */
  static readonly InspectionDataControllerUpdatePath = '/api/inspection-data/{id}';

  /**
   * 검사 자료 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inspectionDataControllerUpdate$Response(params: InspectionDataControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataDto>> {
    return inspectionDataControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 자료 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inspectionDataControllerUpdate(params: InspectionDataControllerUpdate$Params, context?: HttpContext): Observable<InspectionDataDto> {
    return this.inspectionDataControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<InspectionDataDto>): InspectionDataDto => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerDeleteCategory()` */
  static readonly InspectionDataControllerDeleteCategoryPath = '/api/inspection-data/category/{id}';

  /**
   * 검사 자료 카테고리 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerDeleteCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerDeleteCategory$Response(params: InspectionDataControllerDeleteCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataCategoryDto>> {
    return inspectionDataControllerDeleteCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 자료 카테고리 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerDeleteCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  inspectionDataControllerDeleteCategory(params: InspectionDataControllerDeleteCategory$Params, context?: HttpContext): Observable<InspectionDataCategoryDto> {
    return this.inspectionDataControllerDeleteCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<InspectionDataCategoryDto>): InspectionDataCategoryDto => r.body)
    );
  }

  /** Path part for operation `inspectionDataControllerUpdateCategory()` */
  static readonly InspectionDataControllerUpdateCategoryPath = '/api/inspection-data/category/{id}';

  /**
   * 검사 자료 카테고리 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspectionDataControllerUpdateCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inspectionDataControllerUpdateCategory$Response(params: InspectionDataControllerUpdateCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataCategoryDto>> {
    return inspectionDataControllerUpdateCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * 검사 자료 카테고리 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inspectionDataControllerUpdateCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inspectionDataControllerUpdateCategory(params: InspectionDataControllerUpdateCategory$Params, context?: HttpContext): Observable<InspectionDataCategoryDto> {
    return this.inspectionDataControllerUpdateCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<InspectionDataCategoryDto>): InspectionDataCategoryDto => r.body)
    );
  }

}
